import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import locationUtils from 'utils/locationUtils/locationUtils';
import { Loading } from '@jg/components';
import config from 'config/config';
import './LandingSteps.scss';

const LandingSteps = ({ location, isLoading, isError, onCTAClick }) => (
  <section className="landing-steps">
    <div className="landing-steps__inner">
      <h1 className="landing-steps__heading">Make every step count by raising money for the charity of your choice</h1>
      <ol className="landing-steps__list">
        <li className="landing-steps__list__item" style={{ backgroundImage: 'url(src/assets/png/choose-charity.png)' }}>
          <h2>Choose a charity</h2>
          <p>Support one of our partner charities or take your pick</p>
        </li>
        <li className="landing-steps__list__item" style={{ backgroundImage: 'url(src/assets/png/invite-friends.png)' }}>
          <h2>Invite friends</h2>
          <p>Invite friends to match your race miles with a charity donation</p>
        </li>
        <li className="landing-steps__list__item" style={{ backgroundImage: 'url(src/assets/png/match-miles.png)' }}>
          <h2>Match your miles!</h2>
          <p>Make an impact for your charity with every step of your race</p>
        </li>
      </ol>
      <div className="landing-steps__cta-btn__wrapper">
        <Link
          onClick={onCTAClick}
          to={`${config.ROOT_PATH}/charity-search?guid=${location.query.guid}`}
          disabled={isError}
          className={`landing-steps__cta-btn ${isLoading && 'inactive-link'} ${isError && 'is-disabled'}`}
        >
          {
            isLoading ? <Loading size="small" colour="white" /> : 'Ok, Let’s do this!'
          }
        </Link>
      </div>
    </div>
  </section>
);

LandingSteps.propTypes = {
  onCTAClick: PropTypes.func,
  location: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.object])),
  isError: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

LandingSteps.defaultProps = {
  location: locationUtils.locationStub,
  isError: false,
  isLoading: false,
};

export default LandingSteps;



// WEBPACK FOOTER //
// ./components/LandingSteps/LandingSteps.js